import React , { Component } from 'react';
import './App.css';
import LoginPage from './components/LoginPage';
import MainPage from './components/MainPage2';
import LoginService from './serivces/loginService';

class App extends Component {

  constructor(pros) {
    super(pros);
    this.loginService = new LoginService();
  }

  componentDidMount() {
    this.loginService.getCurrent().then((rs) => {
      if (rs == null) {
        // A login may finish while the initial session check is still in flight.
        if (this.loginService.getCookieToken()) return;
        this.setState({loginSuccess: false});
        return;
      }
      this.setState({loginSuccess: true});
    });
  }

  state = { loginSuccess : false }

  loginCompleted = (status = true)=> {
    this.setState({loginSuccess: status});
  }

  render() {
    if (!this.state.loginSuccess) {
      return <LoginPage onLoginCompleted={this.loginCompleted}/>
    }
    return <MainPage gotoLogin={() => this.loginCompleted(false)}></MainPage>;
  }
}

export default App;
